module.exports = __webpack_public_path__ + "static/media/htmlcss.4e95beb5.jpg";